import { useTranslation } from "react-i18next"
import { ManualReservationWrapper } from "./styles"
import { useSetRecoilState } from "recoil"
import { isManualReservationOpen } from "@store/index"

export default function ManualReservation() {
	const { t } = useTranslation()
	const isManualReservationOpenState = useSetRecoilState(
		isManualReservationOpen
	)
	return (
		<ManualReservationWrapper>
			<button onClick={() => isManualReservationOpenState(true)}>
				{t("MANUALRESERVATION.MANUALRESERVATION")}
			</button>
		</ManualReservationWrapper>
	)
}
